<template>
  <main class="content-container">
    <ReservationStatusSearch
      @onSearchFilter="onSearchFilter"
      @onResetFilter="onResetFilter"
    ></ReservationStatusSearch>
    <div>
      <Tab
        v-model="tabIndex"
        class="tabmenu-container-custom"
        :tab-list="tabList"
        @change="onTabChange"
      />
    </div>
    <div class="tab-content">
      <div v-loading="loading" class="grid-scroll">
        <GridVx
          ref="agGrid"
          :auto-size-cell="false"
          :auto-select-first-row="false"
          :columns="columns"
          :rows="rows"
          class="agGrid"
        />
      </div>
      <div class="grid-bottom">
        <GridPaging
          target="agGrid"
          :total-size="pageParams.totalPage"
          :page-num="pageParams.pageNum"
          @pageChanged="onPageChanged"
          @onPageSizeChange="onPageSizeChange"
        />
      </div>
    </div>

    <div class="button-containers mb-0">
      <button class="btn primary small">
        {{ 'Xuất Excel' }}
      </button>
      <button v-if="tabIndex == 1" class="btn primary small outline">
        {{ 'Sửa đặt phòng' }}
      </button>
    </div>
  </main>
</template>
<script>
import { getBookingStatus } from '@/api/reception/reception'
import Tab from '@/components/Tab'
import paginationMixin from '@/mixins/paginationMixin'
import ReservationStatusSearch from '../components/ReservationStatusSearch.vue'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    ReservationStatusSearch,
    Tab
  },
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      searchParams: {
        tab: 1,
        pageSize: 10,
        currentPage: 1
      },
      columns: [
        { headerName: 'Trạng thái', field: 'status_nm' },
        // { headerName: 'Số xác nhận', field: 'confirm_code' },
        { headerName: 'Mã đoàn', field: 'booking_code' },
        { headerName: 'Mã đặt phòng', field: 'room_booking_code' },
        {
          headerName: 'Tên khách',
          valueGetter: params =>
            params.data.last_name + ' ' + params.data.first_name
        },
        { headerName: 'Công ty, đại lý du lịch', field: 'agent_nm' },
        { headerName: 'Hạng phòng', field: 'room_level_cd' },
        { headerName: 'Phòng', field: 'room_num' },
        { headerName: 'Ngày đến', field: 'arrive_date' },
        { headerName: 'Ngày đi', field: 'depart_date' },
        { headerName: 'Số lượng khách', field: 'num_of_guest' },
        // { headerName: 'Trạng thái đặt', field: 'booking_status_nm' },
        {
          headerName: 'Giá phòng',
          field: 'room_price',
          valueFormatter: params => {
            return params.value === null
              ? ''
              : new Intl.NumberFormat().format(params.value)
          }
        },
        {
          headerName: 'Nội bộ',
          headerClass: 'header-cell-center',
          field: 'is_internal',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        },
        {
          headerName: 'Miễn phí',
          headerClass: 'header-cell-center',
          field: 'is_free',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      rows: [],
      tabIndex: 1,
      tabList: [
        { label: 'Folio', value: 1 },
        { label: 'Đoàn (Chưa nhận phòng)', value: 2 }
        // { label: 'Series Booking', value: 3 },
        // { label: 'Allotment', value: 4 },
        // { label: 'Phòng ngưng sử dụng', value: 5 },
        // { label: 'Phòng không phục vụ', value: 6 }
      ]
    }
  },
  watch: {
    tabIndex(value) {
      this.searchParams.tab = this.tabList[value - 1].value
      this.searchParams.currentPage = 1
      this.getTableData()
    }
  },
  methods: {
    async onResetFilter(searchParams) {
      Object.assign(this.searchParams, searchParams)
      await this.getTableData()
    },
    async onSearchFilter(searchParams) {
      Object.assign(this.searchParams, searchParams)
      await this.getTableData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.currentPage = pageNum
      await this.getTableData()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = pageSize
      this.searchParams.pageSize = Number.parseInt(pageSize)
      this.searchParams.currentPage = 1
      await this.getTableData()
    },
    getTableData() {
      this.loading = true
      getBookingStatus(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.rows = res.data
            this.pageParams.totalPage = Math.ceil(
              res.total / this.pageParams.pageSize
            )
            setTimeout(() => {
              this.$refs.agGrid.autoSizeAll()
            }, 0)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
